import { render, staticRenderFns } from "./GroupTypeLimitSelectionConditionItem.vue?vue&type=template&id=2fe90a3a&scoped=true&"
import script from "./GroupTypeLimitSelectionConditionItem.vue?vue&type=script&lang=js&"
export * from "./GroupTypeLimitSelectionConditionItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeLimitSelectionConditionItem.vue?vue&type=style&index=0&id=2fe90a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe90a3a",
  null
  
)

export default component.exports